import axios from 'axios';

const iniciarIntegracao = () => axios.post('integracoes/start');

const getLogsIntegracao = params => axios.get('integracoes/logs', {
  params,
});

const getLogsCompras = (idCompra, params) => axios.get(`compras/${idCompra}/logs-integracoes`, {
  params,
});

const getLogsRequisicao = (idRequisicao, params) => axios.get(`requisicoes/${idRequisicao}/logs-integracoes`, {
  params,
});

export default {
  iniciarIntegracao,
  getLogsIntegracao,
  getLogsCompras,
  getLogsRequisicao,
};
